import { render, staticRenderFns } from "./MergeTable.vue?vue&type=template&id=45e831d2&scoped=true&"
import script from "./MergeTable.vue?vue&type=script&lang=js&"
export * from "./MergeTable.vue?vue&type=script&lang=js&"
import style0 from "./MergeTable.vue?vue&type=style&index=0&id=45e831d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e831d2",
  null
  
)

export default component.exports